<script lang="ts">
  import Seo from '$components/seo.svelte';
  import DynamicBlock from '$components/blocks/dynamic-block.svelte';

  import type { Page } from './content';

  export let data: Page;
</script>

<Seo
  title={data.story.content.seo_title}
  description={data.story.content.seo_description}
  image={data.story.content.seo_og_image}
/>
<div class="[&>:last-child]:pb-5 lg:[&>:last-child]:pb-8">
  {#if data.story.content.body}
    {#each data.story.content.body as b}
      <DynamicBlock block={b} />
    {/each}
  {/if}
</div>
